import {SelectItem} from 'primeng/api';

const vatStatuses: SelectItem<string>[] = [
  { label: 'Not Exempt', value: 'not exempt' },
  { label: 'Exempt', value: 'exempt' }
];

export {
  vatStatuses
}